export default "__VITE_ASSET__BjTnHj5c__"